import type {
  AddToCartSectionShop,
  BaseImage,
  ImageCarousel,
  SanityBlock,
  SanityKeyed
} from 'types/studio/studio';
import type { ProductConnection } from '@portal/gql/shopifyAdmin/graphql';
import type { UnwrapConnection } from '@portal/api/shopifyV2/types';
import { UsedProductsMap } from '@portal/processes/Content/utils';

export type AddToCartSectionProductVariantType = {
  _type: 'Variant';
  hideDoubleSubscription?: boolean;
  addFamilyPlan?: boolean;
  title: string;
  handle: string;
  priceLabel: string;
  image: BaseImage;
  mobileProductImage: BaseImage;
  divider: string;
  singleSubscription: ShopifySubscriptionType;
  doubleSubscription: ShopifySubscriptionType;
  familySubscription: ShopifySubscriptionType;
  oneTime: ShopifySubscriptionType;
  imageCarousel?: ImageCarousel;
};

export const enum CheckoutBaBType {
  ONE_TIME = 'oneTime',
  SUBSCRIPTION = 'subscription'
}

export type AddToCartSectionSubscriptionProductType =
  | 'singleSubscription'
  | 'doubleSubscription'
  | 'familySubscription'
  | 'oneTime';

export type ShopifyProductId = {
  targetStore: 'dev' | 'qa' | 'aud' | 'nzd' | 'eud' | 'ukd' | 'us' | 'au' | 'nz' | 'eu' | 'uk';
  productVariantId: string;
  sellingPlanId: string;
};

export type GiftProductId = {
  targetStore: 'dev' | 'qa' | 'aud' | 'nzd' | 'eud' | 'ukd' | 'us' | 'au' | 'nz' | 'eu' | 'uk';
  variantId: string;
};

export type ShopifySubscriptionType = {
  _type: AddToCartSectionSubscriptionProductType;
  giftProducts?: Array<GiftProductId>;
  giftsListed?: string[];
  productTitle: string;
  productType: AddToCartSectionSubscriptionProductType;
  productIds: Array<ShopifyProductId>;
  subtitle: string;
  priceCaption?: string;
  oldPrice?: string;
  pricePerServing?: string;
  pricePerServingText?: string;
  buttonLabel: string;
  description?: (SanityBlock & { _key: string })[] | undefined;
  isDescriptionBulletList?: boolean;
  isWelcomeKitIncluded?: boolean;
  productOverview: string;
  productHeadlineTitle: string;
  desktopCollageImage?: BaseImage | undefined;
  mobileCollageImage?: BaseImage | undefined;
  sellingPlanId?: string;
  savingsDescription?: string;
  welcomeKitIds?: string[];
  hasBadge?: boolean;
  productBadgeText?: string;
  productBadgeGreen?: boolean;
};

export type BuildBundleMode = 'modal' | 'section';

export interface SanityProps extends SanityKeyed<AddToCartSectionShop> {
  usedProductsMap?: UsedProductsMap;
  productsInventory: UnwrapConnection<ProductConnection>;
  mode?: BuildBundleMode;
  onClose?: () => void;
}

export type ShopifyCartItem = {
  merchandiseId: string;
  quantity: number;
  sellingPlanId?: string;
};
